export default function (...args) {
  console.warn(...args);
}
